import Animation from './animation'
import { EPSILON } from 'chart-constants'

/*
 * A animation that will fade out exiting series and fade in
 * entering series.
 */
class FadingAnimation extends Animation {

  animate (serie, entering, selection, merged, exiting) {
    let fadeOut = this.exitingSeries.filter(f => f.id === serie.id).size()

    if (fadeOut) {
      merged.style('opacity', EPSILON) // Fade out all these points
    }

    let fadeIn = this.series.filter(f => f.id === serie.id).size()

    if (fadeIn && entering.size()) {
      // Throw the entering nodes in the DOM at their full height
      // then fade them in.
      this._insertHidden(entering, serie)
          .transition()
          .duration(this.timing.duration)
          .delay(this.timing.delay)
          .style('opacity', 1)
    }
  }

}

export default FadingAnimation
